import { createFileRoute, Outlet } from '@tanstack/react-router'
import { APP_MENU, APP_MENU_BOTTOM } from '@/app-menu'
import { Guard } from '@/components/state/Guard'
import { KeyOnboarding } from '@/crypto/KeyGate'
import { AppLayout } from '@/ui/layout/AppLayout'

/**
 * Tudo que a terapeuta usa fora da série.
 *
 * Camada sem caminho próprio: ela existe para pendurar a sessão e o shell em
 * cima das rotas `/app`, sem inventar um segmento de URL. A porta de entrada
 * `/app/entrar` fica de fora, senão quem não tem sessão seria mandado para
 * uma tela que também exige sessão.
 */
export const Route = createFileRoute('/_app')({
  component: function AppRoot() {
    return (
      <div data-surface="consultorio" className="h-full">
        {/* biome-ignore lint/a11y/useValidAriaRole: papel da aplicação, não papel ARIA */}
        <Guard role="therapist">
          <KeyOnboarding>
            <AppLayout items={APP_MENU} bottomItems={APP_MENU_BOTTOM}>
              <Outlet />
            </AppLayout>
          </KeyOnboarding>
        </Guard>
      </div>
    )
  },
})
